// extracted by mini-css-extract-plugin
export var formContainer = "_k0-0";
export var message = "_k0-1";